module.exports = __webpack_public_path__ + "img/Headhunter.d43a74b9.svg";